import {
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import Login from "./Screen/Login/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Schoollist from "./Screen/Schoollist/Schoollist";
import { useEffect, useLayoutEffect, useState } from "react";
import Logo from "./assest/logo.png";
import Topbar from "./Components/Topbar/Topbar";
import Schooldetails from "./Screen/Schooldetails/Schooldetails";
import Classdetails from "./Screen/Classdetails/Classdetails";
import Evaluation from "./Screen/Evaluation/Evaluation";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Screen/Loader/Loader";
import Notfound from "./Screen/404page/Notfound";
import useGet from "./Hooks/useGet";
import { Domain, Workspace } from "./path";
import { Set_Loader } from "./Redux/Action/LoaderAction";
import Analysis from "./Screen/Analysis/Analysis";
function App() {
  const Navigation = useNavigate();
  const Dispatch = useDispatch();
  const Location = useLocation();
  const Loading = useSelector((store) => store.Loading);
  const ServerStatus = useGet(`${Workspace[Domain].API_Path}/status`);
  const [Sidebar, setSidebar] = useState({
    sidebar: false,
    logout: false,
    editprofile: false,
  });

  // OPEN AND CLOSE MODAL
  const ModalHandler = (modalname, action) => {
    setSidebar((prev) => ({
      ...prev,
      sidebar: modalname == "sidebar" ? action : false,
      logout: modalname == "logout" ? action : false,
      editprofile: modalname == "edit" ? action : false,
    }));
  };

  const Go_Home = () => {
    let UserID = localStorage.getItem("TEACHER_TOKEN");
    Navigation(`/`);
  };

  useLayoutEffect(() => {
    let UserID = localStorage.getItem("TEACHER_TOKEN");

    if (UserID) {
      // Navigation(`/school/${UserID}`);
    } else {
      Navigation("/login");
    }
  }, []);

  useEffect(() => {
    ServerStatus.refetch(``);
  }, []);
  useEffect(() => {
    if (ServerStatus.data != null) {
      Dispatch(Set_Loader(false));
      switch (ServerStatus?.data?.status) {
        case 200:
          if (ServerStatus?.data?.body?.error == "true") {
            Navigation("/error");
          }
          break;
        case 500:
          Navigation("/error");
          break;
        default:
          break;
      }
    }
  }, [ServerStatus?.data]);

  return (
    <div className="main-container">
      {Loading?.is_load && <Loader />}
      <ToastContainer limit={1} position="top-center" autoClose={1500} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Notfound error={false} />} />
        <Route path="/error" element={<Notfound error={true} />} />

        <Route
          path="/"
          element={
            <Topbar
              Go_Home={Go_Home}
              ModalHandler={ModalHandler}
              modal_opt={Sidebar}
            />
          }
        >
          <Route index element={<Schoollist />} />
          <Route path="schooldetail/:id" element={<Schooldetails />} />
          <Route
            path="classdetail/:school_id/:class_id"
            element={<Classdetails />}
          />
          <Route
            path="evaluation/:school_id/:id/:type/:child_id/:qtype"
            element={<Evaluation />}
          />
          <Route path="analysis/:id/:type" element={<Analysis />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
